export default "__VITE_ASSET__udncxcS4__"